import { Paper, styled } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "24px",
  borderRadius: "8px",
  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
  backgroundColor: theme.palette.mode === "light" ? "#fff" : "#2b2b2b",
}));

export { StyledPaper };
